export default __webpack_public_path__ + "static/media/remove.d71a91ec.svg";